import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Fab, Card, InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import SearchData from "../components/SearchData";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import DowloadBT from "../components/dowloadBT";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 100,
  // },
  // dense: {
  //   marginTop: theme.spacing(2),
  // },
  menu: {
    width: 100,
  },
}));
function CustomToolbar() {
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport
        style={{
          color: "#84BD5A",
          borderColor: "#84BD5A",
          border: "1px solid #84BD5A",
        }}
        printOptions={{ disableToolbarButton: true }}
        csvOptions={{
          fields: ["Status", "ServiceNo", "ServiceName", "EmpName"],
          
        }}
      />
    </GridToolbarContainer>
  );
}
export default function ServiceList() {
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [key,setKey]=useState('')
  
  const debouncedKey = useDebounce(key, 500);const MenuActive = useSelector((state) => state.MenuActive.List);
  /* table data */
  console.log(dataFilter);
  const columns = [
    { field: "ServiceNo", headerName: "Service no.", width: 200 },
    { field: "ServiceName", headerName: "Service Name.", width: 400 },
    // { field: "LocationFrom", headerName: "ต้นทาง", width: 160 },
    // { field: "LocationTo", headerName: "ปลายทาง", width: 160 },

    {
      field: "EmpName",
      headerName: "ผู้สร้าง",
      width: 250,
      renderCell: (params) => {
        console.log(params);
        return (
          <div>
            <span>
              {params.row?.EmpName} {params.row?.EmpLastName && "- "}
              {params.row?.EmpLastName}
            </span>
          </div>
        );
      },
    },

    {
      field: "Status",
      headerName: "Status",
      width: 250,
      valueFormatter: ({ value }) =>
        value === true ? "ACTIVE" : "INACTIVE",
    },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Setting/EditService/${params?.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                Edit
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };

  const fetchServiceList = async () => {
    try {
      const result = await api.get(`api/service/list?keyword=${debouncedKey}`);
      setData(result.data);
      setDataFilter(result.data);
      console.log(result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    fetchServiceList();
  }, [debouncedKey]);

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          บริการ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Service
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Service
            </Typography>
          </Grid>
        </Grid>

        <Grid
          //   container
          //   sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px", display: "flex", flexDirection: "row" ,justifyContent: "end"}}
        >
          {/* <DowloadBT /> */}
          <TextField
           InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          label="Search"
          onChange={e => setKey(e.target.value)}
          size="small"
        />
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.ServiceId}
            rows={dataFilter ? dataFilter : []}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value === true ? "Active" : "Inactive";
              }
            }}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A065") && (
        <Link to="/Setting/AddService">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}
    </div>
  );
}
